import { render, staticRenderFns } from "./officesupplies.vue?vue&type=template&id=22cef0ee&scoped=true"
import script from "./officesupplies.vue?vue&type=script&lang=js"
export * from "./officesupplies.vue?vue&type=script&lang=js"
import style0 from "./officesupplies.vue?vue&type=style&index=0&id=22cef0ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cef0ee",
  null
  
)

export default component.exports